import { Box, Typography } from '@mui/material'
import { Fragment } from 'react'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

import type { PreviousKeywords } from '../../types'
import {
  GUIDANCE_PREP_GRID_2COL_SX,
  GuidancePrepLabel,
} from '../PrescriptionWithDiffPanel'

interface Props {
  data: PreviousKeywords
}

const ROWS: { label: string; key: keyof PreviousKeywords }[] = [
  { label: '症状', key: 'symptoms' },
  { label: '服薬状況', key: 'medication_status' },
  { label: '副作用', key: 'side_effects' },
]

const SEPARATOR = ' ・ '

export const PreviousKeywordsPanel = ({ data }: Props) => (
  <Box sx={GUIDANCE_PREP_GRID_2COL_SX}>
    {ROWS.map(({ label, key }) => {
      const items = data[key]
      const has = items.length > 0
      return (
        <Fragment key={key}>
          <GuidancePrepLabel>{label}</GuidancePrepLabel>
          <Typography
            variant="body2"
            sx={{
              color: has ? colorTokens.fg.default : colorTokens.fg.disabled,
            }}
          >
            {has ? items.join(SEPARATOR) : '—'}
          </Typography>
        </Fragment>
      )
    })}
  </Box>
)
